import * as yup from 'yup';

export const planValidationSchema = yup.object().shape({
	name: yup.string().required('Plan name is required'),
	price: yup
		.number()
		.typeError('Price must be a number')
		.required('Price is required')
		.min(0, 'Price cannot be negative'),
	priceNote: yup.string(),
	limit: yup
		.number()
		.typeError('Limit must be a number')
		.required('Limit is required')
		.min(0, 'Limit cannot be negative')
		.max(100000, 'Max limit is 100000 (Considered as unlimited)'),
	pricePerExtraHaggle: yup
		.number()
		.typeError('Price per extra haggle must be a number')
		.required('Price per extra haggle is required')
		.min(0, 'Price per extra haggle cannot be negative'),
	features: yup
		.array()
		.of(yup.string().trim().required('Feature cannot be empty'))
		.min(1, 'At least one feature is required'),
});
